import React from 'react'
import {useTranslation} from 'react-i18next'

import FeedRoundedIcon from '@mui/icons-material/FeedRounded'
import {List, ListItem, ListItemText} from '@mui/material'
import {PGAvatar, PGCard, PGTypography} from '@progynyglobal/pg-ui-library'

interface JourneyInfoCardProps {
  classes: Record<string, string>
}

type RenderListItemProps = {
  label: string
  desc: string
}

const RenderListItem: React.FC<RenderListItemProps> = (listProps) => {
  const {label, desc} = listProps
  const {t} = useTranslation()
  return (
    <ListItem
      sx={{
        display: 'list-item',
        listStyleType: 'disc',
        pl: 0,
        py: 0.5,
        alignItems: 'flex-start',
      }}
    >
      <ListItemText
        disableTypography
        primary={
          <>
            <PGTypography variant='subheader' component='span'>
              {t(label)} →
            </PGTypography>{' '}
            <PGTypography variant='caption' component='span'>
              {t(desc)}
            </PGTypography>
          </>
        }
      />
    </ListItem>
  )
}

const JourneyInfoCard: React.FC<JourneyInfoCardProps> = (props) => {
  const {classes} = props
  const {t} = useTranslation()

  return (
    <PGCard
      icon={
        <PGAvatar
          variant='primary'
          className={classes.avatarInfo}
          children={<FeedRoundedIcon />}
        />
      }
      header={t('switch_journey_journey_info_card_what_are_different_journeys')}
      className={classes.journeyInfo}
      children={
        <List
          sx={{
            listStyleType: 'disc',
            pl: 3,
          }}
        >
          <RenderListItem
            label={t('journey_management_fertility_title')}
            desc={t('journey_management_fertility_description')}
          />
          <RenderListItem
            label={t('journey_management_p3_title')}
            desc={t('journey_management_p3_description')}
          />
          <RenderListItem
            label={t('journey_management_menopause_title')}
            desc={t('journey_management_menopause_description')}
          />
        </List>
      }
    />
  )
}

export default JourneyInfoCard
